

const AGENTS_IDS_KEY = 'agentsidskeys';

export class AgentsManager {

  private static instance: AgentsManager;
 
  excludedAgentsIds: string[];

  constructor() { }

  static get = (): AgentsManager => {
    if (!AgentsManager.instance) {
      AgentsManager.instance = new AgentsManager();
    }
    return AgentsManager.instance;
  }

  pushAgentsIds = (agents: string[]) => {
    const stored = this.getAgentsIds();
    const merged = Array.from(new Set([...stored, ...agents]));
    localStorage.setItem(AGENTS_IDS_KEY, JSON.stringify(merged));
  }

  getAgentsIds = (): string[] => {
    try {
      const agentsIds = JSON.parse(localStorage.getItem(AGENTS_IDS_KEY)) as string[];
      return agentsIds ? agentsIds : [];
    } catch {
      localStorage.removeItem(AGENTS_IDS_KEY);
      return [];
    }
  }

}
